import Route from '@ember/routing/route';
import { service } from '@ember/service';
import {
  ROUTE_NAME_FOR_STAGE_EDITORS,
  ROUTE_NAME_FOR_STAGE_VIEWERS,
} from 'lumen/utils/constants/otb-selfservice-constants';

export default class HotelSettingsMyotbRoute extends Route {
  @service access;
  @service alerting;
  @service errorTracking;
  @service('hotel-and-market') hotelAndMarketService;
  @service myotbSs;
  @service navigation;
  @service router;
  @service store;

  async afterModel() {
    // The My OTB parent route does not serve anything, redirect to a child route!
    const routeNameForStageMapping = this.myotbSs.canUserEditOtb
      ? ROUTE_NAME_FOR_STAGE_EDITORS
      : ROUTE_NAME_FOR_STAGE_VIEWERS;
    const routeNameForCurrentStage =
      routeNameForStageMapping[this.myotbSs.otbSelfService.stage];

    if (routeNameForCurrentStage === undefined) {
      this.errorTracking.captureMessage('Unknown stage for My OTB');
      this.alerting.showErrorAlert();
      this.router.transitionTo('hotel.settings');
      return;
    }

    this.router.transitionTo(routeNameForCurrentStage);
  }

  beforeModel(transition) {
    if (this.navigation.redirectToAccountSelection(transition)) {
      return;
    }

    if (!this.access.hasFeature('otb.selfservice.view')) {
      this.router.transitionTo('hotel.settings');
    }
  }

  async model() {
    try {
      const otbSelfServices = await this.store.query('otbselfservice', {
        subscription_id: this.hotelAndMarketService.hotel.id,
      });

      this.myotbSs.otbSelfService = otbSelfServices[0];
    } catch (error) {
      this.errorTracking.captureException(error);
      await this.alerting.showErrorAlert();
      window.location.href = '/';
      return null;
    }

    return null;
  }
}
